const PLAN = {
  ENTERPRISE: 'enterprise',
  PROFESSIONAL: 'professional',
  FREE: 'free',
};

export default PLAN;
